import _JSON$stringify from 'babel-runtime/core-js/json/stringify';

import VDistpicker from '@/components/VDistpicker';
import { getBaiduMap } from '@/utils';

export default {
  name: 'XhCustomerAddress', // 新建 客户位置
  components: {
    VDistpicker: VDistpicker
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /** 索引值 用于更新数据 */
    index: Number,
    /** 包含数据源 */
    item: Object
  },
  data: function data() {
    return {
      map: null,
      /** 搜索地图输入框 */
      searchInput: '',
      searchCopyInput: '', // 避免修改
      /** 完整地址输入框 */
      detail_address: '',
      pointAddress: null, // 经纬度点
      /** 区域选择 */
      addressSelect: {
        province: '',
        city: '',
        area: ''
      },
      /** 防止联动情况  */
      canExecute: true
    };
  },

  computed: {},
  watch: {
    pointAddress: function pointAddress(newValue) {
      this.valueChange();
    },
    detail_address: function detail_address(newValue) {
      this.valueChange();
    }
  },
  mounted: function mounted() {
    var _this = this;

    getBaiduMap().then(function () {
      var map = new BMap.Map('choicemap', { enableMapClick: false });
      map.centerAndZoom(new BMap.Point(116.404, 39.915), 14);
      // map.disableDragging() //禁止拖拽
      // map.disableDoubleClickZoom()
      // map.disableScrollWheelZoom()
      // map.disableContinuousZoom()
      map.enableScrollWheelZoom();
      _this.map = map;
      if (_this.value && _JSON$stringify(_this.value) !== '{}') {
        _this.initInfo(_this.value);
      } else {
        // 定位逻辑
        // var geolocation = new BMap.Geolocation()
        // var self = this
        // geolocation.getCurrentPosition(
        //   function(r) {
        //     if (this.getStatus() == BMAP_STATUS_SUCCESS) {
        //       self.addMarkerLabel(r.point)
        //     }
        //   },
        //   { enableHighAccuracy: true }
        // )
      }
    });
  },

  methods: {
    initInfo: function initInfo(val) {
      this.searchInput = val.location;
      this.detail_address = val.detail_address;
      if (Object.prototype.toString.call(val.address) == '[object Array]') {
        var address = {};
        for (var index = 0; index < val.address.length; index++) {
          index === 0 ? address['province'] = val.address[0] : '';
          index === 1 ? address['city'] = val.address[1] : '';
          index === 2 ? address['area'] = val.address[2] : '';
        }
        this.addressSelect = address;
      }
      if (val.lng != 0 && val.lat != 0) {
        this.pointAddress = new BMap.Point(val.lng, val.lat);
        this.addMarkerLabel(this.pointAddress);
      }
    },
    querySearchAsync: function querySearchAsync(queryString, cb) {
      if (queryString) {
        var options = {
          onSearchComplete: function onSearchComplete(results) {
            if (local.getStatus() == BMAP_STATUS_SUCCESS) {
              var address = [];
              for (var i = 0; i < results.getCurrentNumPois(); i++) {
                address.push(results.getPoi(i));
              }
              cb(address);
            } else {
              cb([]);
            }
          },
          pageCapacity: 20
        };
        var local = new BMap.LocalSearch(this.map, options);
        local.search(queryString);
      } else {
        cb([]);
      }
    },

    /** 搜索结果选择 */
    handleSelect: function handleSelect(item) {
      this.searchInput = item.address + item.title;
      this.searchCopyInput = this.searchInput; // 只能通过这种方式修改

      this.detail_address = this.searchInput;
      this.addMarkerLabel(item.point);
      this.pointAddress = item.point;
      this.mapSelectArea(item);
    },

    /** Input 失去焦点  searchInput 只能通过选择更改*/
    inputBlur: function inputBlur() {
      if (this.searchCopyInput !== this.searchInput) {
        this.searchInput = this.searchCopyInput;
      }
    },
    inputFocus: function inputFocus() {
      this.searchCopyInput = this.searchInput;
    },

    // 创建标注
    addMarkerLabel: function addMarkerLabel(point) {
      this.map.clearOverlays();
      this.map.centerAndZoom(point, 14);
      this.map.addOverlay(new BMap.Marker(point));
    },

    /** 区域选择 */
    selectProvince: function selectProvince(value) {
      this.addressSelect.province = value.value;
      this.valueChange();
    },
    selectCity: function selectCity(value) {
      this.addressSelect.city = value.value;
      this.valueChange();
    },
    selectArea: function selectArea(value) {
      this.addressSelect.area = value.value;
      this.valueChange();
    },

    /** 地图选择区域 */
    mapSelectArea: function mapSelectArea(data) {
      if (this.canExecute) {
        this.canExecute = false;
        // this.addressSelect.province = data.province ? data.province : "";
        // this.addressSelect.city = data.city ? data.city : "";
        /** 因为poi里面不包含区域 所以需要逆地址解析 */
        var myGeo = new BMap.Geocoder();
        // 根据坐标得到地址描述
        var self = this;
        myGeo.getLocation(new BMap.Point(data.point.lng, data.point.lat), function (result) {
          if (result) {
            // 获取经纬度点
            self.pointAddress = result.point;
            self.addressSelect.province = result.addressComponents.province ? result.addressComponents.province : '';
            self.addressSelect.city = result.addressComponents.city ? result.addressComponents.city : '';
            self.addressSelect.area = result.addressComponents.district ? result.addressComponents.district : '';
          }
        });

        setTimeout(function () {
          self.canExecute = true;
        }, 500);
      }
    },

    // 值更新的回调
    valueChange: function valueChange() {
      this.$emit('value-change', {
        index: this.index,
        value: {
          address: [this.addressSelect.province, this.addressSelect.city, this.addressSelect.area],
          location: this.searchInput,
          detail_address: this.detail_address,
          lat: this.pointAddress ? this.pointAddress.lat : '',
          lng: this.pointAddress ? this.pointAddress.lng : ''
        }
      });
    }
  }
};